// PCとSPを切り替えるブレイクポイント
//export const breakpoint = 767;
export const breakpoint = 900;
export const containerID = '#c-stranger';
export const assets_path = '/assets/';
